
export enum MatchmakingAction {
    ClickedFindGame = 1,
    ClickedCancelFindGame = 2,
    FinishedWatchingPreRollAdForRankedGameEntry = 3,
}

export const PRIMARY_MATCHMAKING_ACTIONS: readonly MatchmakingAction[] = [
    MatchmakingAction.ClickedFindGame,
    MatchmakingAction.ClickedCancelFindGame,
]
